import { KlaviyoCheckout, LineItem } from "./klaviyo-types";
import { ShopifyCart } from "./shopify-types";

// Shopify Ajax Cart API returns shop money prices in cents
const centsToDollars = (cents?: number): number | undefined =>
	cents === undefined ? undefined : cents / 100;

export const mapShopifyCartToKlaviyoCheckout = (cart: ShopifyCart): KlaviyoCheckout => {
	const lineItems: LineItem[] = cart.items?.map(item => ({
		key: item.key,
		sku: item.sku,
		title: item.title,
		taxable: item.taxable,
		gift_card: item.gift_card,
		line_price_set: {
			shop_money: { amount: centsToDollars(item.price) },
			presentment_money: { amount: item.presentment_price },
		},
		grams: item.grams,
		line_price: centsToDollars(item.line_price),
		product_id: item.product_id,
		variant_id: item.variant_id,
		variant_price: centsToDollars(item.price),
		variant_title: item.variant_title ?? undefined,
		vendor: item.vendor,
		quantity: item.quantity,
		price: centsToDollars(item.price),
		properties: item.properties,
		applied_discounts: item.discounts,
		requires_shipping: item.requires_shipping,
		product: {
			handle: item.handle,
			id: item.product_id,
			title: item.product_title,
			product_type: item.product_type,
			vendor: item.vendor,
			images: item.featured_image ? [{ src: item.featured_image.url, ...item.featured_image }] : [],
		},
	}));

	return {
		"Source Name": "Bolt Managed Checkout",
		"$value": centsToDollars(cart.total_price),
		"Customer Locale": navigator.language,
		"Collections": [], // We don't have a way to get collections from Ajax API
		"Total Discounts": centsToDollars(cart.total_discount),
		"Discount Codes": cart.discount_codes?.filter(d => d.applicable).map(d => d.code) ?? [],
		"Item Count": cart.item_count,
		"Items": cart.items?.map(item => item.title),
		"extra": {
			"referring_site": document.referrer,
			"token": cart.token.split("?")[0], // Only forward the public part of the token, the key should be treated like a secret
			"line_items": lineItems,
			"presentment_currency": cart.currency,
			"note_attributes": Object.entries(cart.attributes ?? {}).map(([k, v]) => ({ "name": k, "value": v })),
		},
	}
}
